import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UserService } from "../../../../domain/user-service";
import { TagRepository } from "../../../../domain/tag-repository";
import { Tag } from "../../../../domain/tag";
import {User} from "../../../../domain/user";
import moment from "moment";
import {UI} from "../../../../services/ui.service";
import {NgxSmartModalService} from "ngx-smart-modal";
import {MediaSegment} from "../../../../domain/media";
import {ELayoutZoneType} from "../../../../domain/layouts/layoutZone";
import {
  ChooseDayAndTimeViewModel
} from "../choose-day-and-time/choose-day-and-time.component";

@Component({
  selector: "icn-text-dynamic-options",
  templateUrl: "./text-dynamic-options.component.html",
  styleUrls: ["./text-dynamic-options.component.scss"],
})
export class GraphicsTextDynamicOptionsComponent implements OnInit {

  private _dayOfWeekDic = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
  };
  @Input() type;

  @Input() isDynamicPromoGraphicInstance: boolean = false;

  @Output()
  dynamicOptionClick = new EventEmitter<string>();

  metadataChosen: string = '***StartTime24h***';
  metadata: [{ name: string; id: number }];
  tagChosen = -1;
  timeZoneChosen = 'channel_timezone';
  currentUser: User;
  tags: Tag[];
  selectedDayOfWeek: number = 0;
  selectedTimeInMinutes: number = 0;

  public get formattedSelectedTime():string {
    let formatedTime = this._dayOfWeekDic[this.selectedDayOfWeek].substring(0, 3) + ", ";
    formatedTime += moment.utc().startOf('day').add("minutes", this.selectedTimeInMinutes).format("HH:mm");
    return  formatedTime;
  }
  allTimeZones: { value: string; displayName: string }[] = [
  ];
  dynamicOptionChosen: { name: string; displayName: string };
  dynamicOptions: { name: string; displayName: string }[] = [
    { name: "current_show_metadata", displayName: "Current Show" },
    { name: "later_show_metadata?skip_shows=1&", displayName: "Next Show" },
    {
      name: "later_show_metadata?skip_shows=2&",
      displayName: "Next Next Show",
    },
    { name: "later_show_metadata?skip_shows=3&", displayName: "Next(x3) Show" },
    { name: "next_time_tag?", displayName: "Next Time" },
    { name: "tomorrow_tag?", displayName: "Tomorrow" },
    { name: "this_week?", displayName: "This Week" },
    { name: "next_week?", displayName: "Next Week" },
    { name: "next_show_with_time_and_tag?", displayName: "Specific Time" },
  ];

  constructor(
    private userService: UserService,
    private tagRepository: TagRepository,
    private _ui: UI,
    private _ngxSmartModalService: NgxSmartModalService,
  ) {}

  ngOnInit() {

    if (this.isDynamicPromoGraphicInstance) {
      this.dynamicOptions.push(
        { name: "promo_for", displayName: "Promo For" },
        { name: "when", displayName: "When" },
      );
    }
    this.currentUser = this.userService.getCurrentUser();
    this.allTimeZones = this.currentUser.timezones.map(z => {
      return { value: z.value, displayName: z.name };
    });
    this.metadata = this.currentUser.metadata;
    this.tags = this.tagRepository
      .getGeneralTags()
      .concat(this.tagRepository.getAssetTypeTags());
    if (this.type === "media") {
      this.dynamicOptions = [
        { name: "current_show_preview", displayName: "Current Show Preview" },
        { name: "current_show_packshot", displayName: "Current Show Packshot" },
        {
          name: "later_show_preview?skip_shows=1&",
          displayName: "Next Show Preview",
        },
        {
          name: "later_show_packshot?skip_shows=1&",
          displayName: "Next Show Packshot",
        },
        {
          name: "later_show_preview?skip_shows=2&",
          displayName: "Next Next Show Preview",
        },
        {
          name: "later_show_packshot?skip_shows=2&",
          displayName: "Next Next Show Packshot",
        },
        {
          name: "later_show_preview?skip_shows=3&",
          displayName: "Next(x3) Show Preview",
        },
        {
          name: "later_show_packshot?skip_shows=3&",
          displayName: "Next(x3) Show Packshot",
        },
      ];
    }
  }

  addDynamicOption() {
    let emitDynamicOptionValue;
    switch (this.dynamicOptionChosen.displayName) {
      case "Current Show": {
        emitDynamicOptionValue =
          "{{" +
          this.dynamicOptionChosen.name +
          "?name=" +
          this.metadataChosen +
          "}}";
        break;
      }
      case "Next Show":
      case "Next Next Show":
      case "Next(x3) Show": {
        let options = ["name=" + this.metadataChosen];

        if (this.tagChosen !== -1) {
          options.push("tag_id=" + this.tagChosen);
          options.push(`tag_name=${this._getTagNameById(this.tagChosen)}`);
        }

        emitDynamicOptionValue =
          "{{" + this.dynamicOptionChosen.name + options.join("&") + "}}";
        break;
      }
      case "Promo For": {
        emitDynamicOptionValue = "{{" + this.dynamicOptionChosen.name + "}}";
        break;
      }
      case "When": {
        emitDynamicOptionValue = "{{" + this.dynamicOptionChosen.name + "}}";
        break;
      }

      case "Tomorrow":
      case "Next Week":
      case "Specific Time":
      case "This Week":
      case "Next Time":
      {
        if (this.tagChosen !== -1 && this.metadataChosen.length > 0) {
            const options = ["name=" + this.metadataChosen];

            if (this.timeZoneChosen.length > 0) {
              options.push("windowsOrIanaTimeZoneId=" + this.timeZoneChosen);
            }
            options.push("tag_id=" + this.tagChosen);
            options.push(`tag_name=${this._getTagNameById(this.tagChosen)}`);

            if (this.dynamicOptionChosen.displayName === 'This Week' || this.dynamicOptionChosen.displayName === 'Next Week' || this.dynamicOptionChosen.displayName === 'Specific Time') {
              options.push("day_of_week=" + this.selectedDayOfWeek);
              options.push("time_of_day=" + moment.utc().startOf('day').add("minutes", this.selectedTimeInMinutes).format("HH:mm"));
            }

            emitDynamicOptionValue =
              "{{" + this.dynamicOptionChosen.name + options.join("&") + "}}";

        } else {
          return;
        }
      }
        break;
      case "Current Show Preview":
      case "Current Show Packshot":
      case "Next Show Preview":
      case "Next Show Packshot":
      case "Next Next Show Preview":
      case "Next Next Show Packshot":
      case "Next(x3) Show Preview":
      case "Next(x3) Show Packshot": {
        let options = [];
        if (this.tagChosen !== -1) {

          options.push("tag_id=" + this.tagChosen);
          options.push(`tag_name=${this._getTagNameById(this.tagChosen)}`);
        }
        emitDynamicOptionValue =
          "{{" + this.dynamicOptionChosen.name + options.join("&") + "}}";
        break;
      }
    }
    this.dynamicOptionClick.emit(emitDynamicOptionValue);
  }

  private _getTagNameById(tagId: number): string {
    const foundTag = this.tags.find((t) => t.id === tagId);
    if (foundTag) {
      return foundTag.name;
    } else {
      return "undefined";
    }
  }

  protected onDayOfWeekClicked(isOpened: boolean) {
    if (isOpened) {
      const chooseDayAndTimePromptVM = new ChooseDayAndTimeViewModel(this.selectedDayOfWeek,this.selectedTimeInMinutes, (vm: ChooseDayAndTimeViewModel) => {
        this.selectedDayOfWeek = vm.dayOfWeek;
        this.selectedTimeInMinutes = vm.selectedTimeInMinutes;

        this._ngxSmartModalService.getModal("chooseDayAndTimePromptModal").close();
      });
      this._ngxSmartModalService.setModalData(chooseDayAndTimePromptVM,
        "chooseDayAndTimePromptModal",
        true
      );
      this._ngxSmartModalService.getModal("chooseDayAndTimePromptModal").open();
    }
  }
}
